export default class TrustdInvitation {

  constructor() {
    this.active = null;
    this.invitationCode = null;
    this.description = null;
    this.channel = null;
    this.email = null;
    this.contactName = null;
    this.company = null;
    this.website = null;
    this.phoneNumber = null;
    this.address = null;
  }

  static create(rawData) {
    let data = JSON.parse(JSON.stringify(rawData));
    console.log('data', data);

    const invitation = new TrustdInvitation();
    invitation.active = data.active;
    invitation.invitationCode = data.invitationCode;
    invitation.description = data.description;
    invitation.channel = data.channel;
    invitation.email = data.email || null;
    invitation.contactName = data.contactName || null;
    invitation.company = data.company || null;
    invitation.website = data.website || null;
    invitation.phoneNumber = data.phoneNumber || null;
    invitation.address = data.address || null;
    return invitation;
  }

}
